import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';

import { SpinnerContainer } from '@/caregiverSpace/shared/ui';

import { useCaregiverCallConfirmationBase } from '../lib/useCaregiverCallConfirmationBase';
import { CaregiverCallConfirmationView } from './CaregiverCallConfirmationView';
import { ServerErrorMessage } from './ServerErrorMessage';

type CaregiverCallConfirmationManagerProps = {
    consultationUid: string;
    onClose: (isAutoClosed?: boolean) => void;
    confirmationType: CaregiverCallConfirmationType;
    onPhoneCallCompleted: () => void;
};

export const CaregiverCallConfirmationManager = ({
    consultationUid,
    onClose,
    confirmationType,
    onPhoneCallCompleted,
}: CaregiverCallConfirmationManagerProps) => {
    const { confirmation, isLoading, error } = useCaregiverCallConfirmationBase(
        {
            consultationUid,
            onClose,
            confirmationType,
        },
    );

    if (isLoading) return <SpinnerContainer />;

    if (error) return <ServerErrorMessage />;

    if (confirmation)
        return (
            <CaregiverCallConfirmationView
                onClose={onClose}
                confirmationType={confirmationType}
                consultationUid={consultationUid}
                onPhoneCallCompleted={onPhoneCallCompleted}
            />
        );
    return null;
};
